type MetaParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

const ONCE_PREFIX = 'cartlens_meta_once_v1';

export function trackMeta(eventName: string, params: MetaParams = {}): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null)
  );
  window.fbq('track', eventName, cleanParams);
}

export function trackMetaCustom(eventName: string, params: MetaParams = {}): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null)
  );
  window.fbq('trackCustom', eventName, cleanParams);
}

export function trackMetaOnce(
  key: string,
  eventName: string,
  params: MetaParams = {}
): void {
  if (typeof window === 'undefined') return;
  const storageKey = `${ONCE_PREFIX}:${key}`;
  try {
    if (localStorage.getItem(storageKey)) return;
    trackMeta(eventName, params);
    localStorage.setItem(storageKey, new Date().toISOString());
  } catch {
    trackMeta(eventName, params);
  }
}

export function trackPlanConversion(params: {
  userId?: string;
  planId: string;
  planName?: string;
  period: 'month' | 'annual' | 'year';
  value?: number;
  currency?: string;
  startsTrial?: boolean;
  trialDays?: number | null;
}): void {
  const period = params.period === 'year' ? 'annual' : params.period;
  const dedupeBase = [
    params.userId || 'anonymous',
    params.planId,
    period,
  ].join(':');

  const common = {
    content_name: params.planName || params.planId,
    content_ids: params.planId,
    content_type: 'product',
    predicted_ltv: params.value,
    value: params.value,
    currency: params.currency || 'USD',
  };

  trackMetaOnce(`subscribe:${dedupeBase}`, 'Subscribe', common);

  if (params.startsTrial) {
    trackMetaOnce(`trial:${dedupeBase}`, 'StartTrial', {
      ...common,
      trial_days: params.trialDays || undefined,
    });
  } else {
    trackMetaOnce(`purchase:${dedupeBase}`, 'Purchase', common);
  }
}
